import { PaperItemStatus } from './types';

export type MetadataField = 'title' | 'abstract' | 'authors';

export interface MetadataInput {
  readonly title: string | null;
  readonly abstractText: string | null;
  readonly authors: readonly string[];
}

export interface StatusInput extends MetadataInput {
  readonly isDuplicate: boolean;
}

/** Required metadata fields that are missing. PDF and DOI are NOT metadata. */
export function missingMetadataFields(p: MetadataInput): MetadataField[] {
  const missing: MetadataField[] = [];
  if (!p.title || p.title.trim().length === 0) missing.push('title');
  if (!p.abstractText || p.abstractText.trim().length === 0) missing.push('abstract');
  if (!p.authors || p.authors.length === 0) missing.push('authors');
  return missing;
}

/**
 * Corpus status. A paper needs attention (NEEDS_METADATA) iff it is missing
 * title, abstract, or authors. PDF and DOI are informational only and never
 * affect status. Duplicates short-circuit.
 */
export function derivePaperStatus(p: StatusInput): PaperItemStatus {
  if (p.isDuplicate) return 'DUPLICATE_SKIPPED';
  if (missingMetadataFields(p).length > 0) return 'NEEDS_METADATA';
  return 'COMPLETE';
}
